import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "souq_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* ignore */ }
  }, [items]);

  const add = (item) => setItems((c) => (c.find((x) => x.lot_id === item.lot_id) ? c : [...c, item]));
  const remove = (lotId) => setItems((c) => c.filter((x) => x.lot_id !== lotId));
  const clearShow = (showId) => setItems((c) => c.filter((x) => x.show_id !== showId));
  const clear = () => setItems([]);
  const has = (lotId) => items.some((x) => x.lot_id === lotId);

  return (
    <CartContext.Provider value={{ items, add, remove, clearShow, clear, has, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
